<div class="modal">

  <fa-icon
    class="modal__close"
    [icon]="['fas', 'times']"
    size="lg"
    title="close"
    (click)="closeDialog()">
  </fa-icon>

  <div
    class="modal__contents"
    [style.height]="height + 'px'">

    <iframe
      *ngIf="src"
      [src]="src"
      class="modal__frame">
    </iframe>

  </div>

</div> 